import { Patient } from 'fhir/r4b';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import CustomBreadcrumbs from 'src/components/CustomBreadcrumbs';
import { getFullName } from 'utils';

export const BreadCrumbs: FC<{ patient: Patient | undefined }> = ({ patient }) => {
  const { t } = useTranslation();
  return (
    <CustomBreadcrumbs
      chain={[
        { link: '/patients', children: t('navbar.patients') },
        {
          link: `/patient/${patient?.id}`,
          children: patient ? getFullName(patient) : '',
        },
        {
          link: '#',
          children: t('patientProfile.breadcrumbs'),
        },
      ]}
    />
  );
};
